import React from 'react';
import type { SVGProps } from 'react';

const TIPollsAppIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none" {...props}>
    <rect width="40" height="40" fill="#f6f4f0" rx="8.906" />
    <path
      fill="#f42a54"
      d="M4.961 8.672h15.547v5.43H4.961zM4.961 25.859h15.547v5.391H4.961zM9.922 14.102h5.625v11.21l-5.469-3.125c-.098-.058-.156-.136-.156-.234zM26.445 8.672h8.594v5.43h-8.594z"
    />
    <path fill="#33373b" d="M21.523 17.266h13.516v5.43H21.523zM24.57 25.859h10.469v5.391H24.57z" />
  </svg>
);

export default TIPollsAppIcon;
